import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OutingIterationDetailsService {

  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  create(form: any){
    return this.http.post(`${this.url}/outingIterationDetail`, form);
  }


  public update(id: string, data: any): any{
    return this.http.put(`${this.url}/outingIterationDetail/${id}`, data)
  }

  public delete(id: string, data: any): any{
    return this.http.post(`${this.url}/outingIterationDetail/delete/${id}`, data);
  }

  getAllByIterationId(filter: any): any{
    return this.http.get(`${this.url}/outingIterationDetails/iteration/${filter.outingIterationId}`, { params: filter });
  }
}
